import options from './paginator.component';

export default {
    selector: 'dtPaginator',
    options
};
